var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":true,"opacity":1,"color":"alabaster"}},[_c('v-progress-linear',{staticStyle:{"width":"100vw"},attrs:{"indeterminate":"","color":"primary","height":2,"rounded":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }